import { render, staticRenderFns } from "./PricesAndIsoInTable.html?vue&type=template&id=519db714&scoped=true&"
import script from "./PricesAndIsoInTable.js?vue&type=script&lang=js&"
export * from "./PricesAndIsoInTable.js?vue&type=script&lang=js&"
import style0 from "./PricesAndIsoInTable.scss?vue&type=style&index=0&id=519db714&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519db714",
  null
  
)

export default component.exports